import {AddressDataModel} from '../person/address-data.model';

export class OrganizationAddressDataModel {
  OrganizationAddressID: string;
  OrganizationID: string;
  AddressId: string;

  dataAddress: AddressDataModel;
}
